import { useNavigate, useLocation } from "react-router-dom";
import { Fragment, useState, useEffect } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { observer } from "mobx-react-lite";
import {
    Bars3Icon,
    HomeIcon,
    UsersIcon,
    XMarkIcon,
    CalendarIcon,
    CalendarDaysIcon,
    ArrowLeftOnRectangleIcon,
    BuildingOfficeIcon,
    SpeakerWaveIcon,
    ChatBubbleBottomCenterIcon,
    LifebuoyIcon,
    SparklesIcon
} from '@heroicons/react/24/outline'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AYJBranding from "../atoms/ayjBranding";
import { useStore } from '../../store';

const navigationMenu = [
    { name: 'Overview', href: '/overview', icon: HomeIcon, current: true },
    { name: 'Company', href: '/company', icon: BuildingOfficeIcon, current: false },
    { name: 'Current Employees', href: '/employees', icon: UsersIcon, current: false },
    { name: 'Past Employees', href: '/past-employees', icon: UsersIcon, current: false },
    { name: 'Attendance', href: '/attendance', icon: CalendarIcon, current: false },
    { name: 'Leave', href: '/leaves', icon: CalendarDaysIcon, current: false },
    // { name: 'Leave History', href: '/leave-history', icon: CalendarDaysIcon, current: false },
    { name: 'Communication', href: '/communication', icon: ChatBubbleBottomCenterIcon, current: false },
    // { name: 'Announcements', href: '/announcements', icon: SpeakerWaveIcon, current: false },
    // { name: 'Reports', href: '/reports', icon: ChartPieIcon, current: false },
    { name: 'Support', href: '/support', icon: LifebuoyIcon, current: false },
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const Layout = ({
    children
}) => {
    const title = window.localStorage.getItem("4r7ur-company") || "Company Portal";
    const userName = window.localStorage.getItem("4r7ur-name") || "User";
    const userTitle = window.localStorage.getItem("4r7ur-title") || "Admin";
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const [navigation, setNavigation] = useState(navigationMenu)
    const navigate = useNavigate();
    const location = useLocation();
    const { layoutStore } = useStore();

    const notify = (message, type) => {
        toast.dismiss();
        toast(message, {
            position: "top-right",
            autoClose: 3000,
            type: type,
        })
    };
    useEffect(() => {
        if (layoutStore.showToast) {
            notify(layoutStore.toastData.message, layoutStore.toastData.type);
        }
    }, [layoutStore.showToast]);
    useEffect(() => {
        const currentPath = location.pathname;
        let updatedNavigation = navigation.map((item) => {
            if (currentPath.includes(item.href)) {
                item.current = true;
            } else {
                item.current = false;
            }
            return item;
        });
        setNavigation(updatedNavigation);
    }, [location]);
    return (
        <>
            <div>
                <Transition.Root show={sidebarOpen} as={Fragment}>
                    <Dialog as="div" className="relative z-40 md:hidden" onClose={setSidebarOpen}>
                        <Transition.Child
                            as={Fragment}
                            enter="transition-opacity ease-linear duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="transition-opacity ease-linear duration-300"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div className="fixed inset-0 bg-gray-600 bg-opacity-75" />
                        </Transition.Child>

                        <div className="fixed inset-0 z-40 flex">
                            <Transition.Child
                                as={Fragment}
                                enter="transition ease-in-out duration-300 transform"
                                enterFrom="-translate-x-full"
                                enterTo="translate-x-0"
                                leave="transition ease-in-out duration-300 transform"
                                leaveFrom="translate-x-0"
                                leaveTo="-translate-x-full"
                            >
                                <Dialog.Panel className="relative flex w-full max-w-xs flex-1 flex-col bg-white">
                                    <Transition.Child
                                        as={Fragment}
                                        enter="ease-in-out duration-300"
                                        enterFrom="opacity-0"
                                        enterTo="opacity-100"
                                        leave="ease-in-out duration-300"
                                        leaveFrom="opacity-100"
                                        leaveTo="opacity-0"
                                    >
                                        <div className="absolute top-0 right-0 -mr-12 pt-2">
                                            <button
                                                type="button"
                                                className="ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                                                onClick={() => setSidebarOpen(false)}
                                            >
                                                <span className="sr-only">Close sidebar</span>
                                                <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
                                            </button>
                                        </div>
                                    </Transition.Child>
                                    <div className="h-0 flex-1 overflow-y-auto pt-5 pb-4">
                                        <div className="flex flex-shrink-0 items-center px-4">
                                            <h1 className='font-black text-2xl text-left cursor-pointer border-b-2 pb-2 text-blue-700'
                                                onClick={() => navigate('/')}
                                            >
                                                {title}
                                            </h1>
                                        </div>
                                        <nav className="mt-5 space-y-1 px-2">
                                            {navigation.map((item) => (
                                                <div
                                                    key={item.name}
                                                    onClick={() => navigate(item.href)}
                                                    className={classNames(
                                                        item.current
                                                            ? 'bg-blue-100 text-blue-900'
                                                            : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900',
                                                        'group flex cursor-pointer items-center px-2 py-2 text-base font-medium rounded-md'
                                                    )}
                                                >
                                                    <item.icon
                                                        className={classNames(
                                                            item.current ? 'text-blue-500' : 'text-gray-400 group-hover:text-gray-500',
                                                            'mr-4 flex-shrink-0 h-6 w-6'
                                                        )}
                                                        aria-hidden="true"
                                                    />
                                                    {item.name}
                                                </div>
                                            ))}
                                            <a
                                                href="https://sponsor-licence-compliance.canny.io/feature-requests"
                                                target="_blank"
                                                className={'text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex cursor-pointer items-center px-2 py-2 text-base font-medium rounded-md'}
                                            >
                                                <SparklesIcon
                                                    className={classNames(
                                                        'text-gray-400 group-hover:text-gray-500',
                                                        'mr-4 flex-shrink-0 h-6 w-6'
                                                    )}
                                                    aria-hidden="true"
                                                />
                                                Feature Requests
                                            </a>
                                            {/* <a
                                                href="https://ayjsolicitors.com/contact-us"
                                                target="_blank"
                                                className={'text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex cursor-pointer items-center px-2 py-2 text-base font-medium rounded-md'}
                                            >
                                                <SpeakerWaveIcon
                                                    className={classNames(
                                                        'text-gray-400 group-hover:text-gray-500',
                                                        'mr-4 flex-shrink-0 h-6 w-6'
                                                    )}
                                                    aria-hidden="true"
                                                />
                                                Get UK Immigration Help
                                            </a> */}
                                        </nav>
                                    </div>
                                    <div className="flex flex-shrink-0 border-t border-gray-200 p-4">
                                        <div className="group block flex-shrink-0">
                                            <div className="flex items-center">
                                                {/* <div>
                                                    <img
                                                        className="inline-block h-10 w-10 rounded-full"
                                                        src="/avatar.png"
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="ml-3">
                                                    <p className="text-base font-medium text-gray-700 group-hover:text-gray-900">{userName}</p>
                                                    <p className="text-sm font-medium text-gray-500 group-hover:text-gray-700">{userTitle}</p>
                                                </div> */}
                                                <a
                                                    target="_blank"
                                                    href="https://ayjsolicitors.com/">
                                                    <p>
                                                        {/* <span className="text-sm text-[#334351] font-semibold"> */}
                                                        <span className="text-sm font-medium text-black group-hover:text-gray-200">
                                                            Created by
                                                        </span>
                                                    </p>
                                                    <img
                                                        className="mt-2 mx-auto"
                                                        src="/ayj.png"
                                                        width={60}
                                                        height={30}
                                                        alt="logo" />
                                                </a>
                                                {/* <ArrowLeftOnRectangleIcon
                                                    onClick={(() => {
                                                        layoutStore.userLogout();
                                                    })}
                                                    className="ml-24 h-6 w-6 text-red-400 cursor-pointer group-hover:text-red-500" aria-hidden="true" /> */}
                                            </div>
                                        </div>

                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                            <div className="w-14 flex-shrink-0">{/* Force sidebar to shrink to fit close icon */}</div>
                        </div>
                    </Dialog>
                </Transition.Root>

                {/* Static sidebar for desktop */}
                <div className="hidden md:fixed md:inset-y-0 md:flex md:w-64 md:flex-col">
                    {/* Sidebar component, swap this element with another sidebar if you like */}
                    <div className="flex min-h-0 flex-1 flex-col border-r border-gray-200 bg-gray-800">
                        <div className="flex flex-1 flex-col overflow-y-auto pt-5 pb-4">
                            <div className=" items-center px-4">
                                <h1 className='font-black text-2xl text-center cursor-pointer border-b-2 pb-2 text-gray-100'
                                    onClick={() => navigate('/')}
                                >
                                    {title}
                                </h1>
                            </div>
                            <nav className="mt-5 flex-1 space-y-1 bg-gray-800 px-2">
                                {navigation.map((item) => (
                                    <div
                                        key={item.name}
                                        onClick={() => navigate(item.href)}
                                        className={classNames(
                                            item.current
                                                ? 'bg-gray-900 text-white'
                                                : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                                            'group flex items-center px-2 py-2 text-base font-medium rounded-md  cursor-pointer'
                                        )}
                                    >
                                        <item.icon
                                            className={classNames(
                                                item.current ? 'text-blue-500' : 'text-gray-400 group-hover:text-gray-500',
                                                'mr-3 flex-shrink-0 h-6 w-6'
                                            )}
                                            aria-hidden="true"
                                        />
                                        {item.name}
                                    </div>
                                ))}
                                <a
                                    href="https://sponsor-licence-compliance.canny.io/feature-requests"
                                    target="_blank"
                                    className={classNames(
                                        'text-gray-300 hover:bg-gray-700 hover:text-white',
                                        'group flex items-center px-2 py-2 text-base font-medium rounded-md  cursor-pointer'
                                    )}
                                >
                                    <SparklesIcon
                                        className={classNames('text-gray-400 group-hover:text-gray-500',
                                            'mr-3 flex-shrink-0 h-6 w-6'
                                        )}
                                        aria-hidden="true"
                                    />
                                    Feature Requests
                                </a>
                                {/* <a
                                    href="https://ayjsolicitors.com/contact-us"
                                    target="_blank"
                                    className={classNames(
                                        'text-gray-300 hover:bg-gray-700 hover:text-white',
                                        'group flex items-center px-2 py-2 text-base font-medium rounded-md  cursor-pointer'
                                    )}
                                >
                                    <SpeakerWaveIcon
                                        className={classNames('text-gray-400 group-hover:text-gray-500',
                                            'mr-3 flex-shrink-0 h-6 w-6'
                                        )}
                                        aria-hidden="true"
                                    />
                                    Get UK Immigration Help
                                </a> */}
                            </nav>
                        </div>
                        <div className="flex justify-center content-center text-white group  py-2 flex items-center ">

                            <div className="flex flex-col justify-center content-center cursor-pointer border-t-2">
                                {/* onClick={() => navigate("https://ayjsolicitors.com/contact-us")}> */}
                                <div className="flex justify-center content-center border-b-2 py-2">

                                    <a href="https://ayjsolicitors.com/contact-us">
                                        <SpeakerWaveIcon
                                            className={classNames(
                                                'text-gray-400 group-hover:text-gray-500',
                                                'mr-4 flex-shrink-0 h-6 w-6'
                                            )}
                                            aria-hidden="true"
                                        />
                                    </a>

                                    <a href="https://ayjsolicitors.com/contact-us">
                                        <span className="
                                        text-gray-300 hover:bg-gray-700 hover:text-white group flex items-center px-2 text-base font-medium cursor-pointer">Get UK Immigration Help</span>
                                    </a>
                                </div>
                                <div className="flex justify-center content-center py-2">
                                    <a
                                        target="_blank"

                                        href="https://ayjsolicitors.com/" className="text-center">
                                        <p>
                                            <span className="text-sm text-[#334351] font-semibold">
                                                Created by
                                            </span>
                                        </p>
                                        <img
                                            className="mt-2 mx-auto hover:text-white"
                                            src="/ayj.png"
                                            width={60}
                                            height={30}
                                            alt="logo" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-1 flex-col md:pl-64">
                    <div className="sticky top-0 z-10 bg-white pl-1 pt-1 sm:pl-3 sm:pt-3 md:hidden">
                        <button
                            type="button"
                            className="-ml-0.5 -mt-0.5 inline-flex h-12 w-12 items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
                            onClick={() => setSidebarOpen(true)}
                        >
                            <span className="sr-only">Open sidebar</span>
                            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                        </button>
                    </div>
                    <main className="flex-1">
                        <AYJBranding 
                        userName = {userName}
                        userTitle = {userTitle}
                        />
                        <div className="py-6">
                            <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8">
                                {/* Replace with your content */}
                                {children}
                                {/* /End replace */}
                            </div>
                        </div>
                    </main>
                </div>
            </div>

            <ToastContainer pauseOnFocusLoss={false}/>
        </>
    )
}
export default observer(Layout);